
const policyName = `REACT_APP_AUTH_SIGNIN_POLICY_${window.location.host}`
const policy = process.env[policyName] !== undefined ? process.env[policyName] : process.env.REACT_APP_AUTH_SIGNIN_POLICY;

const logoutRedirect = policy === process.env.REACT_APP_AUTH_SIGNIN_POLICY_beta_cisternasrepsol ? process.env.REACT_APP_AUTH_LOGOOUT_REDIRECT_URL_beta_cisternasrepsol : window.location.origin;

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AUTH_CLIENT_ID as string,
        authority: `https://globalerisb2c.b2clogin.com/${process.env.REACT_APP_AUTH_TENANT_NAME}/${policy}/`,
        knownAuthorities: ["globalerisb2c.b2clogin.com"],
        redirectUri: window.location.origin,
        postLogoutRedirectUri: logoutRedirect
    }
};

// Scopes you add here will be prompted for consent during login
export const loginRequest = {
    scopes: [process.env.REACT_APP_AUTH_SCOPES] as string[]
};